export default {
  setCurrentQuestion (state, payload) {
    state.currentQuestion = payload
  },
  setAnswers (state, payload) {
    state.answers = payload
  },
  setQuestionFlowData (state, payload) {
    state.questionFlowData = payload
  }
}
